import { render, staticRenderFns } from "./EditPatternDialog.vue?vue&type=template&id=b6edfa1e&scoped=true"
import script from "./EditPatternDialog.vue?vue&type=script&lang=js"
export * from "./EditPatternDialog.vue?vue&type=script&lang=js"
import style0 from "./EditPatternDialog.vue?vue&type=style&index=0&id=b6edfa1e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6edfa1e",
  null
  
)

export default component.exports